// const url = 'http://192.168.3.230:12345';

export const isDevMode = import.meta.env.DEV || window.__DEV__;
// // https://dmitripavlutin.com/environment-variables-javascript/
// const MODE = typeof proccess !== 'undefined' ? process.env.NODE_ENV : import.meta.env.MODE;
// const isDevMode = MODE !== 'production';

export const logger = (...args) => {
  isDevMode && console.log(...args);
  //  fetch(
  //    url +
  //      '/' +
  //      args
  //        .map((x) =>
  //          typeof x === 'object' ? JSON.stringify(x, undefined, 2) : x,
  //        )
  //        .map((x) => x.toString())
  //        .join(' ')
  //        .replaceAll(' ', '_'),
  //  ).catch(() => {});
};

export default function createLogger (name) {
  return (...args) => logger(`[${name}]`, ...args);
}

export function fullLogger (name) {
  const FL = name
    ? (...args) => logger(`%c[${name}]`, ...args)
    : (...args) => logger(...args);
  FL.action = (...args) => FL('background: #222; color: #bada55', ...args);
  FL.end = arg => FL('%c' + arg, 'background: #222; color: #777');
  return FL;
}
